<template>
  <div>
    <Card>
      <template #title>{{ title ? title : 'Отчёты' }}</template>
      <template #content>
        <AbstractTable :code="loanId !== undefined ? 'reportsUnion' : 'reports'" ref="dataTable" :default-data="{eventId: eventId, loanId: loanId}" display-filter="menu">
          <template #additionalButtons>
            <Button
                icon="pi pi-refresh"
                class="p-button-rounded p-button-outlined"
                @click="$refs.dataTable.getData()"
            ></Button>
          </template>
          <template #id="row">
            <IdChip
              :id="row.data.id"
              :view="getView(row.data.reportSource)"
              :menu-items="generateItems(row.data)"
              toast-template='Идентификатор отчёта "{v}" скопирован'
            />
          </template>
          <template #bureau="row">
            {{ $filters.translate($store, 'reportBureaus', row.data.bureau) }}
          </template>
          <template #type="row">
            {{ $filters.translate($store, 'reportTypes', row.data.type) }}
          </template>
          <template #reportSource="row">
            {{ $filters.translate($store, 'reportSource', row.data.reportSource) }}
          </template>
          <template #status="row">
            <StatusChip
              :value="row.data.status"
              compendium="processStatuses"
            />
          </template>
          <template #filename="row">
            <ValueChip
              :value="row.data.filename"
              toast-template='Название файла отчёта "{v}" скопировано'
            />
          </template>
        </AbstractTable>
      </template>
    </Card>
  </div>
</template>

<script>
import AbstractTable from "@/components/AbstractTable";
import StatusChip from "@/components/Common/StatusChip";
import IdChip from "@/components/Common/IdChip.vue";
import ValueChip from "@/components/Common/ValueChip.vue";
export default {
  name: "ReportsTable",
  components: {ValueChip, IdChip, StatusChip, AbstractTable},
  props: {
    title: {
      type: String
    },
    loanId: {
      type: Number
    },
    eventId: {
      type: Number
    }
  },
  methods: {
    generateItems(data) {
      let items = [];

      if (data.fileId !== null) {
        items.push(
          {
            label: 'Скачать файл',
            icon: 'pi pi-fw pi-download',
            command: () => this.downloadReport(data.reportSource, data.id),
          }
        )
      }
      return items
    },
    getView(source) {
      switch (source) {
        case 'delete':
          return 'delete_report_view';
        case 'correction':
          return 'resend_loan_view';
        case 'report':
        default:
          return 'report_view';
      }
    },
    downloadReport(source, id) {
      let entity = 'report';
      if (source === 'delete') {
        entity = 'delete_report';
      } else if (source === 'correction') {
        entity = 'correction_report';
      }
      window.open(`/download/${entity}/${id}`, '_blank');
    }
  }
}
</script>

<style scoped>

</style>